import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';

import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import {
  ConnectAccountToEasyPvInput,
  ConnectAccountToEasyPvMutation,
  DisconnectAccountFromEasyPvMutation,
} from '../../../gql/graphql';

const CONNECT_ACCOUNT_TO_EASY_PV = graphql(`
  mutation ConnectAccountToEasyPV($input: ConnectAccountToEasyPVInput!) {
    connectAccountToEasyPV(input: $input) {
      __typename
      ... on ConnectAccountToEasyPVSuccessResponse {
        id
      }
      ... on ConnectAccountToEasyPVErrorResponse {
        message
      }
    }
  }
`);

export const useConnectAccountToEasyPV = (
  options?: UseMutationOptions<
    ConnectAccountToEasyPvMutation,
    unknown,
    ConnectAccountToEasyPvInput
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(CONNECT_ACCOUNT_TO_EASY_PV, {
        input,
      });
    },
    onSettled: () =>
      queryClient.invalidateQueries({ queryKey: meKeys.integrations() }),
    ...options,
  });
};

const DISCONNECT_ACCOUNT_FROM_EASY_PV = graphql(`
  mutation DisconnectAccountFromEasyPV {
    disconnectAccountFromEasyPV
  }
`);

export const useDisconnectAccountFromEasyPV = (
  options?: UseMutationOptions<
    DisconnectAccountFromEasyPvMutation,
    unknown,
    unknown
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => {
      return gqlClient.request(DISCONNECT_ACCOUNT_FROM_EASY_PV);
    },
    onSettled: () =>
      queryClient.invalidateQueries({ queryKey: meKeys.integrations() }),
    ...options,
  });
};
